import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

export default function RouterErrorPage({ title: propTitle, details }) {
    const navigate = useNavigate();
    const routeError = useRouteError();

    let title = propTitle || "Errore inaspettato";
    let message = "Qualcosa è andato storto. Riprova più tardi.";
    let extra = details;

    // Se non arrivano props dall'ErrorBoundary, usa l'errore del router
    if (!propTitle) {
        if (isRouteErrorResponse(routeError)) {
            title = `Errore ${routeError.status}`;
            message = routeError.statusText || message;
            extra = routeError.data || extra;
        } else if (routeError instanceof Error) {
            message = routeError.message;
            extra = routeError.stack || extra;
        }
    }

    return (
        <div className="mt-4">
            <section className="ul-pricing-table container">
                <div className="row ">
                    <div className="col-lg-12 col-xl-12">
                        <div className="row pt-4">
                            <div className="col-lg-3 col-xl-3 m-0 p-0" />
                            <div className="col-lg-6 col-xl-6 m-0 p-0">
                                <div className="ul-pricing__table-2 rounded" style={{ border: "1px solid #f9f9f9" }}>
                                    <div className="ul-pricing__header">
                                        <div className="ul-pricing__image text-danger my-4">
                                            <i className="i-Close-Window"></i>
                                        </div>
                                        <div className="ul-pricing__main-number my-4">
                                            <h1 className="heading text-danger t-font-boldest">Errore inaspettato</h1>
                                        </div>
                                    </div>
                                    <div className="ul-pricing__title my-4">
                                        <h2 className="heading text-muted">{message}</h2>
                                    </div>

                                    {extra && (
                                        <details className="my-3" style={{ textAlign: "left", margin: "50px" }}>
                                            <summary>DETTAGLI TECNICI</summary>
                                            <b className="mt-2">{title}</b>
                                            <pre className="mt-2" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                                {typeof extra === "string" ? extra : JSON.stringify(extra, null, 2)}
                                            </pre>
                                        </details>
                                    )}

                                    <button
                                        type="button"
                                        onClick={() => navigate("/")}
                                        className="btn btn-lg btn-primary btn-rounded m-1"
                                    >
                                        Torna alla home
                                    </button>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xl-3 m-0 p-0" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
